import Container from './StudioWrapper.container';
import StudioWrapper from './StudioWrapper';

export default Container(StudioWrapper);
